import { Route } from "react-router-dom";

import { ShowProvider } from "../../../providers";
import { AwardTypesPage } from "../Award-Types-List/Award-Types-Page";
import { AwardTypesShow } from "../Award-Types-Show";
import { AwardsPage } from "../Awards-List/Awards-Page";
import { AwardsShow } from "../Awards-Show";

const awardsRoutes = [
  <Route
    key={"award-types"}
    path="award-types"
    element={
      <ShowProvider>
        <AwardTypesPage />
      </ShowProvider>
    }
  />,
  <Route
    key={"award-types-show"}
    path="award-types/:id"
    element={
      <ShowProvider>
        <AwardTypesShow />
      </ShowProvider>
    }
  />,
  <Route
    key={"award-types-create"}
    path="award-types/create"
    element={
      <ShowProvider>
        <AwardTypesShow />
      </ShowProvider>
    }
  />,
  <Route
    key={"awards"}
    path="awards"
    element={
      <ShowProvider>
        <AwardsPage />
      </ShowProvider>
    }
  />,
  <Route
    key={"awards-show"}
    path="awards/:id"
    element={
      <ShowProvider>
        <AwardsShow />
      </ShowProvider>
    }
  />,
  <Route
    key={"awards-create"}
    path="awards/create"
    element={
      <ShowProvider>
        <AwardsShow />
      </ShowProvider>
    }
  />,
];

export const AWARDS_ROUTES = awardsRoutes.map((route) => route);
